import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SectionSeparator from "../SectionSeparator";
import FilePicker from "../FilePicker";

const RequiredDocumentsStep = ({ ctx }) => {
  const { birth_certcopy, center_uuid, child_eid_page, child_eid_page_back, child_passport, document1, errors, father_id_attachment, father_id_attachment_back, father_passport_attachment, formData, med_formcopy, mother_id_attachment, mother_id_attachment_back, mother_passport_attachment, prev_school_rep_doc, setBirthCertcopy, setChildEidPage, setChildEidPageBack, setChildPassport, setDocument1, setFatherIdAttachment, setFatherIdAttachmentBack, setFatherPassportAttachment, setMedFormcopy, setMotherIdAttachment, setMotherIdAttachmentBack, setMotherPassportAttachment, setPrevSchoolRepCopy, setVaccinationCopy, setVisaPage, vaccination_copy, visa_page } = ctx;
  return <>
                {/* Child's Documents */}
                <SectionSeparator title="title.child_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="child_eid_page" file={child_eid_page} setFile={setChildEidPage} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.child_eid_page} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="child_eid_page_back" file={child_eid_page_back} setFile={setChildEidPageBack} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.child_eid_page_back} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="child_passport" file={child_passport} setFile={setChildPassport} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.child_passport} />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="birth_certificate" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="birth_certcopy" file={birth_certcopy} setFile={setBirthCertcopy} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.birth_certcopy} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="immunization_record" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="vaccination_copy" file={vaccination_copy} setFile={setVaccinationCopy} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.vaccination_copy} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_insurance_record" />
                      </Form.Label>
                      <FilePicker name="med_formcopy" file={med_formcopy} setFile={setMedFormcopy} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="visa" />
                      </Form.Label>
                      <FilePicker name="visa_page" file={visa_page} setFile={setVisaPage} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="attended_prev_school_report" />
                      </Form.Label>
                      <FilePicker name="prev_school_rep_doc" file={prev_school_rep_doc} setFile={setPrevSchoolRepCopy} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable
        // error={errors?.prev_school_rep_doc}
        />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="document1" />
                      </Form.Label>
                      <FilePicker name="document1" file={document1} setFile={setDocument1} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Sponsor's Documents */}
                <SectionSeparator title="title.sponsor_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="father_id_attachment" file={father_id_attachment} setFile={setFatherIdAttachment} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.father_id_attachment} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="father_id_attachment_back" file={father_id_attachment_back} setFile={setFatherIdAttachmentBack} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.father_id_attachment_back} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="father_passport_attachment" file={father_passport_attachment} setFile={setFatherPassportAttachment} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.father_passport_attachment} />
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                   <Form.Group className="mb-3">
                    <Form.Label>
                      <FormattedMessage id="visa" />
                    </Form.Label>
                    <FilePicker
                      name="father_visa_attachment"
                      file={father_visa_attachment}
                      setFile={setFatherVisaAttachment}
                      admissionID={formData.admission_id}
                      height={200}
                      uploadable
                    />
                   </Form.Group>
                   </Col> */}
                </Row>

                {/* Spouse's Documents */}
                <SectionSeparator title="title.spouse_documents" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_front" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="mother_id_attachment" file={mother_id_attachment} setFile={setMotherIdAttachment} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.mother_id_attachment} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="emirates_id_back" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="mother_id_attachment_back" file={mother_id_attachment_back} setFile={setMotherIdAttachmentBack} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.mother_id_attachment_back} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="passport" />
                        <span className="required-field-without-position">
                          *
                        </span>
                      </Form.Label>
                      <FilePicker name="mother_passport_attachment" file={mother_passport_attachment} setFile={setMotherPassportAttachment} admissionID={formData.admission_id} center_uuid={center_uuid} height={200} uploadable error={errors?.mother_passport_attachment} />
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                   <Form.Group className="mb-3">
                    <Form.Label>
                      <FormattedMessage id="visa" />
                    </Form.Label>
                    <FilePicker
                      name="mother_visa_attachment"
                      file={mother_visa_attachment}
                      setFile={setMotherVisaAttachment}
                      admissionID={formData.admission_id}
                      height={200}
                      uploadable
                    />
                   </Form.Group>
                   </Col> */}
                </Row>
              </>;
};

export default RequiredDocumentsStep;
